import React, { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";


const BankDetails = ({bankData}) => {
  const { apiURL, apiHeaderJSON, employee_id } = useContext(ConfigContext);
  const [employeeBasicData, setEmployeeBasicData] = useState({});
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    // getUser();
    // getBankInfo();
   
  }, []);
console.log("bankData ====>",bankData)
console.log("bankData?.employee_name_as_per_bank===>",bankData?.employee_name_as_per_bank)
console.log("bankData?.employee_bank_name==>",bankData?.employee_bank_name)
  return (
    <div>
        <div><h5>Bank Details</h5></div>
        <div className="card-body p-md-4 p-0">
          <div className="tab-content">
            <div className="tab-pane active show" id="personalDetails" role="tabpanel">
              <form action="javascript:void(0);">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="bankRecord" className="form-label">
                        Name As Per Bank Record:
                      </label>
                      <input
                        value={bankData?.[0]?.employee_name_as_per_bank || "--"}
                        type="text"
                        className="form-control"
                        id="bankRecord"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="bankName" className="form-label">
                        Bank Name:
                      </label>
                      <input
                        value={bankData?.[0]?.employee_bank_name || "--"}
                        type="text"
                        className="form-control"
                        id="bankName"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="accountNumber" className="form-label">
                        Account Number:
                      </label>
                      <input
                        value={bankData?.[0]?.employee_bank_account_number || "--"}
                        type="text"
                        className="form-control"
                        id="accountNumber"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="branchName" className="form-label">
                        Branch Name:
                      </label>
                      <input
                        value={bankData?.[0]?.employee_bank_branch_name || "--"}
                        type="text"
                        className="form-control"
                        id="branchName"
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-3">
                      <label htmlFor="ifscCode" className="form-label">
                        IFSC Code:
                      </label>
                      <input
                        value={bankData?.[0]?.employee_bank_Ifsc || "--"}
                        type="text"
                        className="form-control"
                        id="ifscCode"
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
    </div>
  );
};

export default BankDetails;
